import { Route, Routes } from "react-router-dom"
import M2MPush from "../../pages/M2MPush"
import PushTransferConfirm from "../../pages/M2MPush/PushTransferConfirm"
import PushForbidden from "../../pages/M2MPush/PushForbidden"
import { ROUTES_PATHS } from "../../utils/constants"

// подтверждение перевода в другой банк
const M2MPushFlow = () => (
  <Routes>
    <Route index element={<M2MPush />} />
    <Route
      element={<PushTransferConfirm />}
      path={`/:${ROUTES_PATHS.incomeTransferRequestId}/${ROUTES_PATHS.confirm}`}
    />
    <Route
      element={<PushForbidden />}
      path={`/:${ROUTES_PATHS.incomeTransferRequestId}/${ROUTES_PATHS.forbidden}`}
    />
  </Routes>
)

export default M2MPushFlow
